import { Sponsorstripe } from '@schibsted/advertory/aftenposten/cjs';
import React, { useEffect, useRef } from 'react';
import { MapProvider } from 'react-map-gl/maplibre';

import type { FrapiTeaserItem } from '../../../types/frapi-types.js';
import type { ListPageProps } from './index.js';

import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import Navigation from '../../components/commonComponents/Navigation/Navigation.js';
import { ListsProvider } from '../../components/saving/ListsProvider.js';
import { TopList } from './TopList/index.js';
import {
  getRelatedTopLists,
  toRelatedTopListTeaser,
} from './utils/related-top-list.js';
import { RenderContextProvider } from '../../contexts/RenderContext.js';

const ListPageV2: React.FC<ListPageProps> = ({ data, options }) => {
  const { siteVersion, isHermesApp, currentUrl } = options;
  const { properties, items } = data;

  const isMobile = siteVersion === 'phone';

  const ref = useRef<HTMLDivElement>(null);

  const { trackViewListing } = usePulseContext();

  useEffect(() => {
    trackViewListing({
      object: {
        id: 'list-page:top-list',
        name: 'list page - top list',
        'spt:custom': {
          currentUrl,
          topListVersion: 2,
        },
      },
    });
  }, [trackViewListing, currentUrl, data]);

  const relatedTopLists = getRelatedTopLists(data.properties);
  const relatedTopListTeasers = relatedTopLists
    .slice(0, 2)
    .map((list) => toRelatedTopListTeaser(list, isMobile, 580, 768));

  return (
    <RenderContextProvider isHermesApp={isHermesApp} siteVersion={siteVersion}>
      <MapProvider>
        <ListsProvider>
          <div ref={ref} className={`${siteVersion}-front`}>
            <Navigation
              fullWidth={!isMobile}
              activeSection="restaurantguiden"
            />
            <Sponsorstripe targetId="sponsorstripe" />
            <TopList
              title={properties.h1}
              description={properties.description}
              teasers={items as FrapiTeaserItem[]}
              relatedTopListTeasers={relatedTopListTeasers}
            />
          </div>
        </ListsProvider>
      </MapProvider>
    </RenderContextProvider>
  );
};

export { ListPageV2 };
